export const CALENDAR_VIEW = {
  DAY: 'DAY',
  LIST: 'LIST',
  MONTH: 'MONTH',
  WEEK: 'WEEK',
} as const;

export enum CALENDAR_WEEK_STARTS_ON {
  SUN,
  MON,
}

export const CALENDAR_ENCODER_FILTER_KEY = 'calendar-encoder-filter-key';
export const CALENDAR_EVENT_TYPE_FILTER_KEY = 'calendar-event-type-filter-key';
export const CALENDAR_VIEW_KEY = 'calendar-view-key';
export const CALENDAR_WEEK_STARTS_ON_KEY = 'calendar-week-starts-on-key';

export const CREATE_OPTIONS = {
  BROADCAST: 'broadcast',
  REPLAY: 'replay',
  LIBRARY_VIDEO: 'libraryVideo',
  CLIP_POST: 'clipPost',
} as const;
